function moveStickyCTA() {
    const reasons = document.querySelector('#reasons');

    if (reasons.dataset.sticky !== undefined) {
        const stickyCTA = document.querySelector('#stickyCTA');
        const position = document.querySelectorAll('.reasons__item');

        position[reasons.dataset.sticky - 1].after(stickyCTA)
    }
}

moveStickyCTA();

function expandContent(el) {

    el.addClass('toCollapse').next('.reasons__content').addClass('toExpand');

}

$('.reasons__triggerContent').on('click', function() {
    let trigger = $(this);    

    expandContent(trigger)
});